$(function () {
    $(".v2-custom-dropdown").on("show.bs.dropdown", function () {
        $(".v2-custom-dropdown").not(this).each(function () {
            const $otherDropdown = $(this);
            if ($otherDropdown.hasClass("show")) {
                $otherDropdown.removeClass("show");
                $otherDropdown.find(".dropdown-menu").removeClass("show");
            }
        });

        $(".dropdown-overlay").addClass("show");
        $("body").addClass("dropdown-open");
    });

    $(".v2-custom-dropdown").on("hide.bs.dropdown", function (e) {
        if ($(this).is("#crypto-address-book")) {
            if (
                !e.clickEvent
                ||
                (e.clickEvent &&
                    $(e.clickEvent.target).closest(".dropdown-menu").length > 0 &&
                    $(e.clickEvent.target).data("dismiss") != "dropdown" &&
                    !$(e.clickEvent.target).closest(".v2-dropdown-item").length)
            ) {
                e.preventDefault();
                return;
            }
        } else {
            if (!e.clickEvent) {
                e.preventDefault();
                return;
            }
        }

        $(".dropdown-overlay").removeClass("show");
        $("body").removeClass("dropdown-open");
    });
});